import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./notification.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { notificationsStore, selectNotifications } from '~/modules/stores/notifications/notificationsStore';
class Notification extends LightningElement {
  constructor(...args) {
    super(...args);
    this.notifications = [];
    this.hasNotifications = false;
  }
  notificationsConnected(storeNotifications) {
    this.notifications = storeNotifications.sort((a, b) => b.id - a.id).slice(0, 3).map((notification, index) => ({
      notification,
      index
    }));
    this.hasNotifications = this.notifications.length !== 0;
  }
  handleClose(event) {
    notificationsStore.removeNotification(parseInt(event.currentTarget.dataset.index));
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Notification, {
  track: {
    notifications: 1
  },
  wire: {
    notificationsConnected: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: notificationsStore,
          selector: selectNotifications
        };
      }
    }
  },
  fields: ["hasNotifications"]
});
const __lwc_component_class_internal = _registerComponent(Notification, {
  tmpl: _tmpl,
  sel: "appx-notification",
  apiVersion: 62
});
export default __lwc_component_class_internal;